import { lazy, Suspense } from "react";
import { Header } from "@/components/Header";
import { HomeHero } from "@/components/HomeHero";
import { GrowthPainPoints } from "@/components/GrowthPainPoints";
import { AsSeenIn } from "@/components/AsSeenIn";
import { WhySwitch } from "@/components/WhySwitch";
import { WhyWeCare } from "@/components/WhyWeCare";
import { WhatAccountantsGetWrong } from "@/components/WhatAccountantsGetWrong";
import { StructuredData } from "@/components/StructuredData";
import { Footer } from "@/components/Footer";
import { LazySection } from "@/components/LazySection";
import { Head } from "vite-react-ssg";

// Below-the-fold components - lazy loaded for smaller initial bundle
const Reviews = lazy(() => import("@/components/Reviews").then((m) => ({ default: m.Reviews })));
const Services = lazy(() => import("@/components/Services").then((m) => ({ default: m.Services })));
const Industries = lazy(() => import("@/components/Industries").then((m) => ({ default: m.Industries })));
const HowWeWorkTogether = lazy(() =>
  import("@/components/HowWeWorkTogether").then((m) => ({ default: m.HowWeWorkTogether })),
);
const BrandMission = lazy(() => import("@/components/BrandMission").then((m) => ({ default: m.BrandMission })));
const MapSection = lazy(() => import("@/components/MapSection").then((m) => ({ default: m.MapSection })));
const ExitIntentPopup = lazy(() =>
  import("@/components/ExitIntentPopup").then((m) => ({ default: m.ExitIntentPopup })),
);

const Index = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "hsl(40 30% 97%)" }}>
      <Head>
        <title>Small Business Tax & Accounting | Manassas VA | Hollins & Hur</title>
        <meta
          name="description"
          content="Licensed CPAs & Enrolled Agents for small business tax prep, filing, and proactive planning in Manassas & Northern VA/DC. Clear process, fast communication. Book a free fit call."
        />
        <meta
          name="keywords"
          content="CPA Manassas VA, small business accountant Northern Virginia, tax preparation Manassas, bookkeeping DC area, business advisory Virginia"
        />

        <link rel="preload" as="image" href="/src/assets/hero-professional-work-min.jpg" />
        <meta name="author" content="Hollins & Hur" />
        <meta name="geo.region" content="US-VA" />
        <meta name="geo.placename" content="Manassas, Virginia" />
        <meta property="og:title" content="Small Business Tax & Accounting | Manassas VA | Hollins & Hur" />
        <meta
          property="og:description"
          content="Licensed CPAs & Enrolled Agents for small business tax prep, filing, and proactive planning in Manassas & Northern VA/DC. Clear process, fast communication. Book a free fit call."
        />
        <meta name="twitter:title" content="Small Business Tax & Accounting | Manassas VA | Hollins & Hur" />
        <meta
          name="twitter:description"
          content="Licensed CPAs & Enrolled Agents for small business tax prep, filing, and proactive planning in Manassas & Northern VA/DC. Book a free fit call."
        />
      </Head>
      <StructuredData type="home" />
      <Header />
      <main>
        {/* Above the fold - load immediately */}
        <HomeHero />
        <AsSeenIn />
        <GrowthPainPoints />
        <WhySwitch />
        

        {/* Below the fold - lazy load */}
        <LazySection placeholder={<div className="min-h-[400px] bg-[hsl(350_70%_45%)]" />}>
          <Suspense fallback={<div className="min-h-[400px] bg-[hsl(350_70%_45%)]" />}>
            <Reviews />
          </Suspense>
        </LazySection>

        <LazySection placeholder={<div className="min-h-[400px]" />}>
          <Suspense fallback={<div className="min-h-[400px]" />}>
            <Services />
          </Suspense>
        </LazySection>

        <LazySection placeholder={<div className="min-h-[400px]" />}>
          <Suspense fallback={<div className="min-h-[400px]" />}>
            <Industries />
          </Suspense>
        </LazySection>

        <LazySection placeholder={<div className="min-h-[300px]" />}>
          <Suspense fallback={<div className="min-h-[300px]" />}>
            <HowWeWorkTogether />
          </Suspense>
        </LazySection>

        <LazySection placeholder={<div className="min-h-[400px]" />}>
          <Suspense fallback={<div className="min-h-[400px]" />}>
            <BrandMission />
          </Suspense>
        </LazySection>

        {/* Why we care section */}
        <WhyWeCare />

        <LazySection placeholder={<div className="min-h-[400px]" />}>
          <Suspense fallback={<div className="min-h-[400px]" />}>
            <MapSection />
          </Suspense>
        </LazySection>
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ExitIntentPopup />
      </Suspense>
    </div>
  );
};

export default Index;
